import Img from '../Img';

export default (props) => {
  return (
    <a href="https://wingapp.onelink.me/wEYd/ohbq8c6b" target="_blank" rel="noreferrer">
      <Img {...props} />
    </a>
  );
};
